export { SERVICE_NAME as TECHNICAL_PERMISSION_SERVICE_NAME, TechnicalPermissionService } from './technical-permission.service'
